var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3635 6.64361L11.3635 6.64363L11.3665 6.64058C11.6518 6.34536 11.6561 5.87597 11.3635 5.58339C11.0725 5.29242 10.5942 5.29242 10.3033 5.58339L7.05337 8.83328L5.69682 7.47672C5.40585 7.18575 4.92756 7.18575 4.6366 7.47672C4.34563 7.76768 4.34563 8.24598 4.6366 8.53694L6.52326 10.4236C6.66295 10.5633 6.85298 10.6435 7.05337 10.6435C7.25376 10.6435 7.4438 10.5633 7.58348 10.4236L11.3635 6.64361ZM1.58337 8.00016C1.58337 4.4649 4.46478 1.5835 8.00004 1.5835C11.5353 1.5835 14.4167 4.4649 14.4167 8.00016C14.4167 11.5354 11.5353 14.4168 8.00004 14.4168C4.46478 14.4168 1.58337 11.5354 1.58337 8.00016Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.ecac0b15511bffc2b8497567287f3fcd.svg";
export { ForwardRef as ReactComponent };